import {
  PaginatedWorkersQueryQueryCgResponse,
  PaginatedWorkersQueryQueryVariables,
} from '@common/graphql';
import { gql, TypedDocumentNode } from '@common/hooks';

export const PAGINATED_WORKERS_QUERY: TypedDocumentNode<
  PaginatedWorkersQueryQueryCgResponse,
  PaginatedWorkersQueryQueryVariables
> = gql`
  query PaginatedWorkersQuery(
    $limit: Int!
    $offset: Int!
    $orderDirection: OrderDirection
    $orderField: WorkerOrderField
    $filters: WorkerFilterInput
  ) {
    paginatedWorkers(
      limit: $limit
      offset: $offset
      orderDirection: $orderDirection
      orderField: $orderField
      filters: $filters
    ) {
      workers {
        id
        createdAt
        employeeId
        worksUser {
          id
          firstName
          lastName
          email
          timeZoneAbbreviation
        }
        homeUnit {
          id
          name
          costCenter
        }
        allowedUnits {
          id
          name
        }
        role {
          id
          abbreviation
        }
        workforceGroup {
          id
          name
        }
      }
      totalCount
    }
  }
`;

export type PaginatedWorkersType =
  PaginatedWorkersQueryQueryCgResponse['paginatedWorkers']['workers'];
